module.exports = __webpack_public_path__ + "static/media/ControlCenter.d8b93fa6.svg";